module.exports = __webpack_public_path__ + "static/media/oksana_soloveva_avatar.99e9bb91.jpg";